import { Component, Input } from '@angular/core';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { HxSupplierService } from 'hx-services';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

interface Address {
  type: string;
  city: string;
  address: string;
}

@Component({
    selector: 'app-suppliers-address',
    templateUrl: './suppliers-address.component.html',
    styleUrls: ['./suppliers-address.component.css'],
    imports: [NgIf, NgFor, FormsModule, TranslocoPipe]
})
export class SuppliersAddressComponent {
  list: Address[] = [];
  types = ['ACTUAL', 'LEGAL'];
  _id;
  @Input()
  set id(val) {
    this._id = val || null;
    if (val) {
      this.getList();
    }
  }
  get id() {
    return this._id;
  }
  isLoading = {
    list: false,
  };

  constructor(
    private supplierService: HxSupplierService,
    private toastr: HcToastrService,
    private tr: TranslocoService
  ) { }

  private getList() {
    this.list = [];
    this.isLoading.list = true;

    this.supplierService.getSupplierAddressesById(this.id).subscribe(
      result => {
        this.list = result || [];
        this.isLoading.list = false;
      },
      err => {
        this.isLoading.list = false;
      }
    );
  }

  private addItem() {
    this.list.push({
      city: '',
      type: '',
      address: ''
    });
  }

  private deleteItem(addressId) {
    if (addressId) {
      this.supplierService.removeSupplierAddress(this.id, addressId).subscribe(result => {
        this.toastr.success(this.tr.translate('suppliers-address.ts.deleteAddress'));
        this.getList();
      });
    }
  }

  // public API
  public addField() {
    this.addItem();
  }

  public updateData(item) {
    if (this.id) {
      let api = this.supplierService.createSupplierAddress(this.id, [item]);

      if (item && item.id) {
        const obj = {
          type: item.type,
          city: item.city,
          address: item.address,
        };

        api = this.supplierService.updateSupplierAddress(this.id, item.id, obj);
      }

      api.subscribe(
        result => {
          this.toastr.success(this.tr.translate('suppliers-address.ts.saveAddress'));
          this.getList();
        },
        result => {
          this.toastr.error(this.tr.translate('suppliers-address.ts.error'));
        }
      );
    }
  }

  public removeField(item, index) {
    if (item && item.id) {
      this.deleteItem(item.id);
    } else {
      this.list.splice(index, 1);
    }
  }
}
